// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1nJ2n","detailsBorder":"styles_detailsBorder__34WwG"};